/**
 * Returns a copy of the `items` array, excluding the `value`.
 */
const exclude = (value, items) => {
  return items.filter(item => item !== value);
};

/**
 * Returns a copy of the `items` array, including the `value`.
 */
const include = (value, items) => {
  return items.concat(value);
};

export { exclude as e, include as i };
